module.exports = __webpack_public_path__ + "img/hipercard.a0c5b92e.svg";